// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"435":"19e584bb","647":"44110604"}[chunkId] + ".chunk.css";
};